"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f449 = void 0;
exports.f449 = {
    "ǁkxau": [
        2673
    ],
    "ǁgana": [
        2713
    ],
    "ǁani": [
        3003
    ],
    "ǁanikhwe": [
        3003
    ],
    "ǁaikwe": [
        5460
    ],
    "ǁaisan": [
        5460
    ],
    "ǁaiǁe": [
        5460
    ],
    "ǁaiǁen": [
        5460
    ],
    "ǁxegwi": [
        8452
    ],
    "ǁxegwe": [
        8452
    ],
    "ǁxekwi": [
        8452
    ]
};
